"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageLayoutContext = exports.usePageLayout = void 0;
const react_1 = require("react");
const PageLayoutContext = (0, react_1.createContext)(undefined);
exports.PageLayoutContext = PageLayoutContext;
/**
 * Context to allow the PageLayout parts to access common stuff.
 */
const usePageLayout = () => {
    const context = (0, react_1.useContext)(PageLayoutContext);
    if (!context) {
        throw new Error("usePageLayout must be used within a PageLayout");
    }
    return context;
};
exports.usePageLayout = usePageLayout;
